import styled from 'styled-components';

const HorizontalLine = styled.hr`
  width: 100%;
  border-bottom: 1px solid black;
  border-top: 0px;
  margin: 20px 0;
`;

export default HorizontalLine;
